export function caseStudySlider() {
    let slider = $(".case-study-slider");
    slider.slick({
        arrows: true,
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: "<button type='button' class='slick-prev slick-arrow'><svg width=\"18\" height=\"10\" viewBox=\"0 0 18 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M6.70213 10V5.50562H18V4.49438H6.70213V0L0 4.98876L6.70213 10Z\" fill=\"#133440\"/>\n" +
            "</svg>\n</button>",
        nextArrow: "<button type='button' class='slick-next slick-arrow'><svg width=\"18\" height=\"10\" viewBox=\"0 0 18 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M11.2979 10V5.50562H0V4.49438H11.2979V0L18 4.98876L11.2979 10Z\" fill=\"#133440\"/>\n" +
            "</svg></button>",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/caseStudySlider.js